// extracted by mini-css-extract-plugin
module.exports = {"container":"StructureRow_container__YwU3p","admin":"StructureRow_admin__1WkHp","icon":"StructureRow_icon__2lUXf"};